module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Colleagues', [(_vm.loading) ? _c('Loader') : (_vm.colleagues.length > 0) ? _vm._l((_vm.colleagues), function(user) {
    return _c('section', {
      staticClass: "media d-flex flex-wrap align-items-center"
    }, [_c('figure', {
      staticClass: "media-left mb-1"
    }, [_c('img', {
      staticClass: "image is-64x64",
      attrs: {
        "src": user.avatar_url
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content d-flex flex-wrap flex-column"
    }, [_c('strong', [_vm._v(_vm._s(user.name || user.email))]), _vm._v(" "), (user.school) ? _c('div', [_c('label', {
      staticClass: "fw-500"
    }, [_vm._v("School")]), _vm._v(" "), _c('small', [_vm._v(_vm._s(user.school))])]) : _vm._e(), _vm._v(" "), (user.position) ? _c('div', [_c('label', {
      staticClass: "fw-500"
    }, [_vm._v("Position")]), _vm._v(" "), _c('small', [_vm._v(_vm._s(user.position))])]) : _vm._e(), _vm._v(" "), (user.content_area) ? _c('div', [_c('label', {
      staticClass: "fw-500"
    }, [_vm._v("Content Area")]), _vm._v(" "), _c('small', [_vm._v(_vm._s(user.content_area))])]) : _vm._e(), _vm._v(" "), (user.grade) ? _c('div', [_c('label', {
      staticClass: "fw-500"
    }, [_vm._v("Grade")]), _vm._v(" "), _c('small', [_vm._v(_vm._s(user.grade))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "media-right align-self-center d-flex justify-content-end grow-1"
    }, [_c('button', {
      staticClass: "button is-danger is-outlined",
      on: {
        "click": function($event) {
          _vm.removeColleague(user)
        }
      }
    }, [_vm._v("Remove")])])])
  }) : _c('section', [_c('p', {
    staticClass: "text-center fs-7 text-muted mt-4"
  }, [_vm._v("You don't have any colleagues yet.")]), _c('p'), _c('p', {
    staticClass: "text-center fs-5 text-muted"
  }, [_vm._v("Visit the \"Find Colleagues\" tab above to add some.")])]), _vm._v(" "), _c('Confirm', {
    attrs: {
      "show": _vm.confirmShow,
      "title": _vm.confirmTitle,
      "message": _vm.confirmMessage,
      "confirmFocus": true,
      "completeButtonText": 'Remove'
    },
    on: {
      "cancel": _vm.cancelAction,
      "confirm": _vm.confirmAction
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-0ced9cb2"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyColleagues.vue
// module id = 979
// module chunks = 0